import { gql } from "@apollo/client";

export const GET_UI = gql`
{
  ui @client {
    sideBarOpen
  }
}`